import { render, staticRenderFns } from "./KasPiutangList.vue?vue&type=template&id=673920b2"
import script from "./KasPiutangList.vue?vue&type=script&lang=js"
export * from "./KasPiutangList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports